var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('potential-applicants',{attrs:{"isProgram":true,"currentStatus":_vm.currentStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }